import React from "react";
import Marquee from "react-fast-marquee";

export const TaglineMarquee = ({
  items = ["Crafted with Purpose", "Handcrafted Stories", "Worn with Grace", "Made to Measure"],
  dark = false,
  speed = 30,
}) => (
  <div
    data-testid="tagline-marquee"
    className={`py-8 border-y ${dark ? "border-white/10 bg-[#121212] text-[#F5F2EA]" : "border-[#D5D0C5] bg-[#F5F2EA] text-[#121212]"}`}
  >
    <Marquee speed={speed} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-4xl sm:text-6xl font-light italic px-8">{t}</span>
          <span className="text-[#C6A15B] text-4xl px-2">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
